import { FormField } from "@shared/services/FormServices";
import {
  CreditCard,
  FileText,
  Workflow,
  Database,
  Users,
} from "lucide-react";
import { useNavigate } from "react-router-dom";


// integration landing cards ==========
export const configCards = [
  {
    icon: CreditCard,
    title: "Payment Gateways",
    description: "Configure Stripe, DOKU, and Razorpay payment processors",
    navigate: '/integration-hub/integration/payments',
  },
  // {
  //   icon: FileText,
  //   title: "Document Management",
  //   description: "Connect to document storage and processing services",
  //   navigate: '/integration-hub/integration/payments',
  // },
  // {
  //   icon: Workflow,
  //   title: "Workflow Automation",
  //   description: "Set up integrations with workflow automation tools",
  //   navigate: '/integration-hub/integration/payments',
  // },
  // {
  //   icon: Database,
  //   title: "Data Connectors",
  //   description: "Connect to external data sources and APIs",
  //   navigate: '/integration-hub/integration/payments',
  // },
  // {
  //   icon: Users,
  //   title: "Authentication",
  //   description: "Configure SSO and identity providers",
  //   navigate: '/integration-hub/integration/payments',
  // },
];


export const PSP_FIELD_DEFINITIONS: Record<string, FormField[]> = {
  stripe: [
    {
      name: "apiKey",
      label: "API Key",
      type: "text",
      placeholder: "sk_live...",
    },
    {
      name: "secretKey",
      label: "Secret Key",
      type: "text",
      placeholder: "rk_live...",
      customValidation: (value) => {
        if (!value || value.trim().length < 2) {
          return "Secret key must be at least 2 characters";
        }
        return true;
      },
    },
    {
      name: "webhook_url",
      label: "Webhook URL",
      type: "text",
      required: false,
      placeholder: "https://api.smart360.io/webhooks/stripe",
      disabled: true,
    },
    {
      name: "webhookSecret",
      label: "Webhook Secret",
      type: "password",
      placeholder: "whsec_...",
    },
    {
      name: "publicKey",
      label: "Public Key",
      type: "text",
      placeholder: "pk_live...",
    },
  ],
};

// 🟢 Only raw reusable Doku fields (no version/env logic here)
export const BASE_DOKU_FIELDS: FormField[] = [
  {
    name: "mallId",
    label: "Mall ID",
    type: "text",
    required: true,
    placeholder: "Enter Mall ID",
  },
  {
    name: "chainMerchantId",
    label: "Chain Merchant ID",
    type: "text",
    required: true,
    placeholder: "Enter Chain Merchant ID",
  },
  {
    name: "secretKey",
    label: "Secret Key",
    type: "text",
    required: true,
    placeholder: "Enter Secret Key",
  },
  {
    name: "sharedKey",
    label: "Shared Key",
    type: "text",
    required: true,
    placeholder: "Enter Shared Key",
  },
  {
    name: "apiKey",
    label: "API Key",
    type: "text",
    required: true,
    placeholder: "Enter API Key",
  },
  {
    name: "webhook_url",
    label: "Webhook URL",
    type: "text",
    required: false,
    placeholder: "https://api.smart360.io/webhooks/doku",
    disabled: true,
  },
];

